<template>
  <div>
    <!-- List Table -->
    <List
      :header="header"
      :data="data"
      :pagination="pagination"
      :loading="loading"
      @updatePage="updatePage"
      @click="clickField"
      detailUrl="/my-cloud/cloud-nodes"
      :moduleName="`servers.cloudNodes`"
      :moduleCreateEvent="`subHeaderDetailOpen`"
      :moduleSearch="search"
    >
      <template v-slot:item.datacenterName="{ item }">
        {{
          item.datacenter & item.datacenter.data
            ? item.datacenter.data.name
            : '-'
        }}
      </template>

      <template v-slot:item.cloudVendor="{ item }">
        {{
          item.product &&
          item.product.data &&
          item.product.data.vendor &&
          item.product.data.vendor.data
            ? item.product.data.vendor.data.name
            : '-'
        }}
      </template>

      <template v-slot:item.is_public="{ item }">
        {{ $t(item.is_public ? 'global.yes' : 'global.no') }}
      </template>
    </List>

    <!-- Create Popup -->
    <DetailModal
      :title="$t('servers.createCloudNode')"
      :show="showDetail"
      @closeDetail="closeDetail()"
      @confirm="confirmModal()"
      :resetForm="resetForm"
    >
      <CreateCloudNode
        :confirmModal="confirmCreate"
        @resetDetailForm="resetDetailForm"
      />
    </DetailModal>
  </div>
</template>

<script>
// Utils
import { SET_BREADCRUMB } from '@/core/services/store/breadcrumbs.module'
import { SET_CUSTOMHEADERPARAMS } from '@/core/services/store/customsubheader.module'
import EventBus from '@/event-bus'

// Services
import ApiService from '@/core/services/api.service'

export default {
  name: 'CloudNodes',
  data() {
    return {
      search: '',
      filters: '',
      showDetail: false,
      resetForm: false,
      confirmCreate: false,
      loading: false,
      header: [
        { text: 'servers.cloudNode', value: 'name', clicked: true },
        { text: 'servers.datacenter', value: 'datacenterName' },
        { text: 'servers.cloudVendor', value: 'cloudVendor' },
        { text: 'servers.pricingModel', value: 'pricing_model' },
        { text: 'global.isPublic', value: 'is_public' },
        { text: 'global.country', value: 'country' },
      ],
      data: [],
      pagination: {},
      meta: {},
    }
  },
  created() {
    this.getList()
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: 'servers.cloudNodes',
        route: '/my-cloud/cloud-nodes',
      },
    ])
    this.$store.dispatch(SET_CUSTOMHEADERPARAMS, {
      menuList: [
        {
          title: 'servers.myCloud',
        },
        {
          title: 'servers.cloudNodes',
          route: '/my-cloud/cloud-nodes',
        },
      ],
      searchPlaceholder: 'detail.searchForName',
      detailPlaceholder: 'servers.createCloudNode',
    })

    EventBus.$on(`subHeaderSearch`, this.listenersubHeaderSearch)
    EventBus.$on(`subHeaderDetailOpen`, this.listenersubHeaderDetailOpen)
  },
  beforeDestroy() {
    EventBus.$off(`subHeaderSearch`, this.listenersubHeaderSearch)
    EventBus.$off(`subHeaderDetailOpen`, this.listenersubHeaderDetailOpen)
  },
  methods: {
    listenersubHeaderSearch(payload) {
      this.search = payload
      this.getList()
    },
    listenersubHeaderDetailOpen(payload) {
      this.showDetail = payload
    },
    getList() {
      this.loading = true

      const { current_page } = this.meta

      let $query = `iaas/datacenter-nodes?include=datacenter&orderBy=position|ASC&page=${
        current_page ? current_page : 1
      }`

      if (this.search) $query += `&name=${this.search}`

      ApiService.get($query)
        .then(({ data }) => {
          this.data = data.data
          this.pagination = data.meta ? data.meta.pagination : {}

          this.loading = false
        })
        .catch((err) => {
          console.log(err)
          this.data = []
          this.loading = false
        })
    },
    updatePage(value) {
      this.meta = value

      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      })
    },
    clickField(item) {
      this.$router.push('/my-cloud/cloud-nodes/' + item.id)
    },
    confirmModal() {
      this.confirmCreate = true
      setTimeout(() => {
        this.confirmCreate = false
      }, 200)
    },
    resetDetailForm(closeDetail = false) {
      if (closeDetail) {
        this.closeDetail()
        this.getList()
      }

      this.resetForm = true
      setTimeout(() => {
        this.resetForm = false
      }, 200)
    },
    closeDetail() {
      this.showDetail = false
    },
  },
  watch: {
    meta: {
      handler() {
        this.getList()
      },
      deep: true,
    },
  },
  components: {
    CreateCloudNode: () => import('@/components/forms/CreateCloudNode'),
  },
}
</script>
